<template>
  <div class="thumbnail_card">
    <div class="imgbox">
      <img :src="education.thumbnail">
    </div>
    <h3 class="thumbnail_title" :title="education.title">{{education.title}}</h3>
    <p class="thumbnail_desc m-0 oneline_text">{{(education.description.length<100)?education.description:education.description | truncate(100)}}</p>
    <div class="card_footer_btn">
      <button class="btn hf-btn-info card_btn_w btn_h"  @click='getScenarioByEducation(education.id)' type="button">Use This</button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
        return {
            liveCampaigns: [],
            baseUrl: baseUrl,
        }
    },
    props: ['education'],
    // watch: {

    // },
    beforeMount() {


    },
    methods: {

        getScenarioByEducation(id) {
            $('#myModal').modal('hide');
            
            let data = {
                education_id: [id]
            }

            this.$http.post('/library/scenarios', data).then((response) => {
                this.$parent.filteredScenarios = response.data.data;
                $('#myScenarioModal').modal('show');
            })
        }
    }
}
</script>
 


// WEBPACK FOOTER //
// educationCard.vue?a5202a60